import { useMutation } from 'react-query';
import { insurance_request_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';

export function useCreateInsuranceRequest() {
  const api = useAPI();

  return useMutation(insurance_request_api.createInsuranceRequest(api));
}
